import SlidingService from "./SlidingService";

/**
 * @deprecated Prefer {@link SlidingService} play methods directly.
 * Kept for existing imports (`SlidingPuzzlePlay`, library panels).
 */
const SlidingPlayService = {
    listSlidingPlay: (params) => SlidingService.listPlay(params),

    startSlidingPlay: async (_cloudUserId, slidingId) => {
        const result = await SlidingService.startPlay(slidingId);
        return result.success ? result.data : null;
    },

    restartSlidingPlay: async (_cloudUserId, slidingId) => {
        const result = await SlidingService.restartPlay(slidingId);
        return result.success ? result.data : null;
    },

    progressSlidingPlay: async (_cloudUserId, slidingId, payload) => {
        const result = await SlidingService.progressPlay(slidingId, payload);
        return result.success ? result.data : null;
    },
};

export default SlidingPlayService;
